import { Table } from '@apache-arrow/esnext-umd'
export class Subscription {
  subscribed: boolean;
  subtopics: {[k: string]: any};
}
export class NotificationStateModel {
  subscriptions: {[k: string] : Subscription};
  permission: string;
  subscriptionHash: string | boolean;
}

export class SubscribeTopic {
  static readonly type = '[Notification] Subscribe to Topic';
  constructor(public payload: { topic: string, extendedTopic?: string }) {}
}

export class PermissionChange {
  static readonly type = '[Notification] update permission';
  constructor(public payload: { state: string }) {}
}
export class NotificationReceived {
  static readonly type = '[Notification] notification received'
  constructor(public payload: Table) {}
}

export class DeregisterDevice {
  static readonly type = '[Notification] Deregister Device';
}
export class RegisterDevice {
  static readonly type = '[Notification] Register Device';
}

export const KnownTopics = {
  ScraperUpdate: `gapmaps.internal.scraper.updates`
}
